@use '@lib/assets/styles/main.scss' as *;

.tagsRow {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding-top: 16px;
  & > div {
    max-width: 100%;
  }
}
